import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { TransportorSocietyService } from 'src/app/services/transportor-society/transportor-society.service';

@Component({
  selector: 'app-edit-trailer',
  templateUrl: './edit-trailer.component.html',
  styleUrls: ['./edit-trailer.component.css'],
})
export class EditTrailerComponent implements OnInit {
  @Output() result = new EventEmitter<any>();
  @Input() trailerId: any;

  @ViewChild('autoInput') input: any;

  isClicked: Boolean = false;

  trailer: any;
  offers: any;
  plateformList: any = [];
  transportorTypes: any = [];
  form?: FormGroup | any;

  selectedCmds: any = [];
  collectorList: any = [];
  pickupsList: any = [];

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private service: CommandesService,
    private transServices: TransportorSocietyService,
  ) {
    this.form = this.fb.group({
      trailerId: [null],
      selectedTransportor: [null, Validators.required],
      transportorType: [null, Validators.required],
      remorqueId: ['', Validators.required],
      plateform: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this._initForm();

    this.listCollectors();
  }

  async _initForm() {
    this.trailer = await this.service.getOneTrailer(this.trailerId);
    // console.log(this.trailer);

    if (this.trailer) {
      const selectedTrans = this.trailer?.transportor?._id;
      this.form = this.fb.group({
        trailerId: this.trailer?._id,
        selectedTransportor: this.fb.control(selectedTrans, {
          validators: [Validators.required],
        }),
        transportorType: this.fb.control(this.trailer?.transportorType, {
          validators: [Validators.required],
        }),
        remorqueId: this.fb.control(this.trailer?.remorqueId, {
          validators: [Validators.required],
        }),
        plateform: this.fb.control(this.trailer?.plateform, {
          validators: [Validators.required],
        }),
        // offers: this.fb.array([])
      });

      this.selectedCmds = this.trailer?.commands;

      /// get data contact selected transportor
      this.transServices
        .getContractSociety(selectedTrans)
        .then(async (res: any) => {
          // console.log("getContractSociety : ")
          // console.log(res)
          this.offers = res?.data?.offers;
          this.plateformList = this.offers
            .map((item) => item?.plateform)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.transportorTypes = Array.from(
            new Set(
              this.offers
                .filter((o) => o?.type === 'transport')
                .reduce((acc: string[], o) => {
                  const v = o?.labels;
                  if (Array.isArray(v)) {
                    for (const t of v) if (t && t.trim()) acc.push(t);
                  } else if (typeof v === 'string' && v.trim()) {
                    acc.push(v);
                  }
                  return acc;
                }, [] as string[]),
            ),
          );
        });
    } else {
      alert('Aucune remorque valide');
      location.href = '/all-trailers';
    }
  }

  async listCollectors() {
    await this.transServices.allSocieties().then((res: any) => {
      if (res) {
        // console.log("leader res");
        // console.log(res);
        this.collectorList = res;
      }
    });
  }

  deleteTrailer(cmdId) {
    if (this.selectedCmds?.length == 1) {
      alert('La liste des commandes ne doit pas être vide !');
    } else {
      this.selectedCmds = this.selectedCmds.filter((cmd) => cmd?._id !== cmdId);
    }
  }

  update() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isClicked = true;

    const data = this.form.value;
    data.cmds = this.selectedCmds.map((item) => item?._id);

    data.totalVolume = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.totalVolume) || 0),
      0,
    );
    data.totalWeight = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.totalPoids) || 0),
      0,
    );
    data.totalCost = this.selectedCmds.reduce(
      (acc, item) => acc + (Number(item.total_ca_cmd) || 0),
      0,
    );

    // console.log(data);

    this.service.updateTrailer(data).then(async (res: any) => {
      // console.log('resssssssss : ');
      // console.log(res);
      if (res?.response) {
        this.result.emit(true);
        this.activeModal.dismiss();
      } else {
        alert(res?.msg);
      }
    });
  }

  async onChange() {
    this.pickupsList = await this._searchPickups(
      this.input.nativeElement.value,
    );
  }
  private _searchPickups(keyword: string) {
    let promise = new Promise<any>(async (resolve, reject) => {
      await this.service
        .searchCmd(null, keyword, 'take_off')
        .then((res: any) => {
          console.log(res);
          if (res) {
            resolve(res);
          }
        })
        .catch((e: any) => {
          resolve([]);
        });
    });
    return promise;
  }

  onSelectionChange(event: any) {
    const selectedPickup = event.option.value;
    // console.log(this.selectedPickup)

    this.input.nativeElement.value = '';

    // Vérifier l'existence
    const exists = this.selectedCmds.some((item) =>
      item._id ? item._id === selectedPickup._id : false,
    );

    if (!exists) {
      this.selectedCmds.push(selectedPickup);
    }

    this.pickupsList = [];
  }

  closeModal() {
    this.result.emit(null);
    this.activeModal.dismiss();
  }
}
